<div class="box">
    <h1 class="mt-5 mb-5">Page Not found</h1>
    <span>{{message}}</span>
</div>